import React, { useState } from 'react'
import { Link as GLink } from 'gatsby'
import { Flex } from 'rebass'
import PropTypes from 'prop-types'
import { Logo, Wrapper, FoldOut, MenuToggle } from './styles'
import { BigLetters } from '../Text'
import plxlogo from '../../images/plx_logo.png'

const propType = {
  items: PropTypes.array.isRequired,
}

const Link = ({ children, slug, externalUrl, ...props }) => {
  if (!slug && externalUrl) {
    return (
      <a href={externalUrl} {...props}>
        {children}
      </a>
    )
  }
  if (slug && !externalUrl) {
    return (
      <GLink to={slug} {...props}>
        {children}
      </GLink>
    )
  }
  return <GLink {...props}>{children}</GLink>
}

Link.propTypes = {
  children: PropTypes.node.isRequired,
  slug: PropTypes.string,
  externalUrl: PropTypes.string,
}
const MenuContent = ({ items = [], close }) => (
  <FoldOut>
    {items.map(x => (
      <Link key={x.contentful_id} onClick={close} {...x}>
        <BigLetters>{x.title}</BigLetters>
      </Link>
    ))}
  </FoldOut>
)

MenuContent.propTypes = {
  close: PropTypes.func.isRequired,
  ...propType,
}

const Menu = ({ items = [], title, invertLogo }) => {
  const [open, toggle] = useState(false)
  return (
    <Flex>
      {open ? <MenuContent close={() => toggle(false)} items={items} /> : null}
      <Wrapper>
        <Flex>
          <Link css={{ pointerEvents: 'auto' }} to="/" title={title}>
            <Logo invert={open ? false : invertLogo} width={1} src={plxlogo} alt="plx logo" />
          </Link>
          <MenuToggle onClick={() => toggle(!open)} isOpen={open} />
        </Flex>
      </Wrapper>
    </Flex>
  )
}

Menu.propTypes = {
  ...propType,
  title: PropTypes.string.isRequired,
  invertLogo: PropTypes.bool,
}

export default Menu
